<ng-container *ngIf="productRequest">
    <div class="capsule" [class.complete]="(productRequest | approvedProductRequestItemCount) === productRequest.items.length">
        {{ productRequest | approvedProductRequestItemCount }}/{{ productRequest.items.length }} {{'product_requests.approval_status.approved' | translate}}
    </div>
</ng-container>
